import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../hoc/Auxilary";
import { Button } from "rsuite";
import SelectionFields from "../../../../hoc/UI/SelectionFields/SelectionFields";

class ContractForm extends Component {

    render() {
        const validAndHandle = (func, values) => {
            this.props.validateForm().then(errors => {
                var dates = ["design_start_date",
                    "design_completion_date",
                    "construction_start_date",
                    "substantial_completion_date",
                    "final_completion_date",
                    "rfi_issue_date",
                    "rfi_response_date",
                    "rfq_issue_date",
                    "rfq_response_date",
                    "rfq_shortlisting_date",
                    "rfp_issue_date",
                    "rfp_response_date",
                    "rfp_award_date",
                    "contract_award_date",
                    "commercial_close_date",
                    "engineers_cost_estimate_date",
                    "engineers_estimated_substantial_completion_date",
                    "engieering_estimated_final_completion_date",
                    "winning_bidder_estimated_substantial_completion_date",
                    "winning_bidder_estimated_final_completion_date",
                    "financial_close_date",
                ];
                if (Object.keys(errors).length !== 0) {
                    this.props.setFieldTouched("contract_name", true);
                    this.props.setFieldTouched("is_master_contract", true);
                    this.props.setFieldTouched("design_start_date", true);
                    this.props.setFieldTouched("design_completion_date", true);
                    this.props.setFieldTouched("construction_start_date", true);
                    this.props.setFieldTouched("substantial_completion_date", true);
                    this.props.setFieldTouched("final_completion_date", true);
                    this.props.setFieldTouched("rfi_issue_date", true);
                    this.props.setFieldTouched("rfi_response_date", true);
                    this.props.setFieldTouched("rfq_issue_date", true);
                    this.props.setFieldTouched("rfq_response_date", true);
                    this.props.setFieldTouched("rfq_shortlisting_date", true);
                    this.props.setFieldTouched("rfp_issue_date", true);
                    this.props.setFieldTouched("rfp_response_date", true);
                    this.props.setFieldTouched("rfp_award_date", true);
                    this.props.setFieldTouched("contract_award_date", true);
                    this.props.setFieldTouched("commercial_close_date", true);
                    this.props.setFieldTouched("engineers_cost_estimate_date", true);
                    this.props.setFieldTouched("engineers_estimated_substantial_completion_date", true);
                    this.props.setFieldTouched("engieering_estimated_final_completion_date", true);
                    this.props.setFieldTouched("winning_bidder_estimated_substantial_completion_date", true);
                    this.props.setFieldTouched("winning_bidder_estimated_final_completion_date", true);
                    this.props.setFieldTouched("financial_close_date", true);
                    this.props.setFieldTouched("additional_days_gained", true);
                    this.props.setFieldTouched("display_order", true);
                    this.props.setFieldTouched("number_of_days_of_liquidated_damage", true);
                    this.props.setFieldTouched("num_change_orders", true);
                    this.props.setFieldTouched("value_change_orders", true);
                    this.props.setFieldTouched("num_of_claims", true);
                    this.props.setFieldTouched("value_of_claims", true);
                    this.props.setFieldTouched("liquidated_damage_cost", true);
                    this.props.setFieldTouched("num_of_rfi_submittals", true);
                    this.props.setFieldTouched("num_of_rfq_submittals", true);
                    this.props.setFieldTouched("num_of_rfp_addenda_by_purpose", true);
                    this.props.setFieldTouched("num_of_submittals_in_response_to_rfp", true);
                    this.props.setFieldTouched("total_stipends", true);
                    this.props.setFieldTouched("number_of_subcontractors", true);
                    this.props.setFieldTouched("fte_hours_to_oversee_procurement", true);
                    this.props.setFieldTouched("engineers_cost_estimate", true);
                    this.props.setFieldTouched("project_cost_at_commercial_close", true);
                    this.props.setFieldTouched("project_cost_at_financial_close", true);
                    console.log("cannot submit! Validation failed", errors);
                } else {
                    values.project_id = this.props.projectID;

                    dates.forEach(field => {
                        if (values[field]) {
                            values[field] = new Date(values[field]).toJSON();
                        }
                    });

                    func(values);
                    this.props.resetForm();
                    this.props.toggleSmallModalHandler();
                }
            });
        };

        if (!this.props.values.is_master_contract) {
            this.props.values.is_master_contract = false;
        }

        return (
            <Form>
                <div onClick={this.props.toggleSmallModalHandler} style={{"color" : "red", float:"right", cursor:"pointer"}}>x</div>
                <fieldset disabled={this.props.disabled}>
                    <small className={"d-block col-12"}><span style={{color:"red"}}>*</span> required</small>
                    <div className={"d-inline-block col-3 pl-2"}>
                        <label
                            htmlFor={"contract_name"}
                            className="required"
                            style={this.props.errors.contract_name && this.props.touched.contract_name && {color: "red"}}
                        >
                            <span>Contract Name</span>
                        </label>
                        <Field
                            style={this.props.errors.contract_name && this.props.touched.contract_name && {borderColor: "red"}}
                            className="form-control-sm form-control"
                            id={"contract_name"}
                            name={"contract_name"}
                            value={this.props.values.contract_name || ""}
                        />
                        {this.props.errors.contract_name && this.props.touched.contract_name && (
                            <small className="text-danger">{this.props.errors.contract_name}</small>
                        )}
                    </div>

                    <div className={"d-inline-block col-3 pl-2"}>
                        <label
                            className={"required"}
                            style={this.props.errors.is_master_contract && this.props.touched.is_master_contract !== undefined && {color: "red"}}
                            htmlFor={"is_master_contract"}>
                            Is Master Contract
                        </label>

                        <Field
                            style={this.props.errors.is_master_contract && this.props.touched.is_master_contract !== undefined && {borderColor: "red"}}
                            className="form-control"
                            id={"is_master_contract"}
                            name={"is_master_contract"}
                            component={"select"}
                            value={this.props.values["is_master_contract"]}
                        >
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                        </Field>
                        {this.props.errors.is_master_contract && this.props.touched.is_master_contract && (
                            <small className={"text-danger"}>{this.props.errors.is_master_contract}</small>
                        )}
                    </div>






                    <label className="col-3 pl-2" style={this.props.errors.additional_days_gained && this.props.touched.additional_days_gained && {color: "red"}}>
                        Additional Days Gained
                        <Field
                            className="form-control-sm form-control"
                            name={"additional_days_gained"}
                            value={this.props.values.additional_days_gained || null}
                        /> {this.props.errors.additional_days_gained && this.props.touched.additional_days_gained && (
                <small className="text-danger">{this.props.errors.additional_days_gained}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.display_order && this.props.touched.display_order && {color: "red"}}>
                        Display Order
                        <Field
                            className="form-control-sm form-control"
                            name={"display_order"}
                            value={this.props.values.display_order || null}
                        /> {this.props.errors.display_order && this.props.touched.display_order && (
                <small className="text-danger">{this.props.errors.display_order}</small>
            )}
                    </label>

                    <label className="col-3 pl-2" style={this.props.errors.commercial_close_date && this.props.touched.commercial_close_date && {color: "red"}}>
                        Commercial Close Date
                        <Field
                            className="form-control-sm form-control"
                            name={"commercial_close_date"}
                            value={this.props.values.commercial_close_date || null}
                        /> {this.props.errors.commercial_close_date && this.props.touched.commercial_close_date && (
                <small className="text-danger">{this.props.errors.commercial_close_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.construction_partnering_workshops && this.props.touched.construction_partnering_workshops && {color: "red"}}>
                        Construction Partnering Workshops
                        <Field
                            className="form-control-sm form-control"
                            name={"construction_partnering_workshops"}
                            value={this.props.values.construction_partnering_workshops || null}
                        /> {this.props.errors.construction_partnering_workshops && this.props.touched.construction_partnering_workshops && (
                <small className="text-danger">{this.props.errors.construction_partnering_workshops}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.construction_start_date && this.props.touched.construction_start_date && {color: "red"}}>
                        Construction Start Date
                        <Field
                            className="form-control-sm form-control"
                            name={"construction_start_date"}
                            value={this.props.values.construction_start_date || null}
                        /> {this.props.errors.construction_start_date && this.props.touched.construction_start_date && (
                <small className="text-danger">{this.props.errors.construction_start_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.contract_award_date && this.props.touched.contract_award_date && {color: "red"}}>
                        Contract Award Date
                        <Field
                            className="form-control-sm form-control"
                            name={"contract_award_date"}
                            value={this.props.values.contract_award_date || null}
                        /> {this.props.errors.contract_award_date && this.props.touched.contract_award_date && (
                <small className="text-danger">{this.props.errors.contract_award_date}</small>
            )}
                    </label>

                    <label className="col-3 pl-2" style={this.props.errors.cost_note && this.props.touched.cost_note && {color: "red"}}>
                        Cost Note
                        <Field
                            className="form-control-sm form-control"
                            name={"cost_note"}
                            value={this.props.values.cost_note || null}
                        /> {this.props.errors.cost_note && this.props.touched.cost_note && (
                <small className="text-danger">{this.props.errors.cost_note}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.cost_type && this.props.touched.cost_type && {color: "red"}}>
                        Cost Type
                        <Field
                            className="form-control-sm form-control"
                            name={"cost_type"}
                            value={this.props.values.cost_type || null}
                        /> {this.props.errors.cost_type && this.props.touched.cost_type && (
                <small className="text-danger">{this.props.errors.cost_type}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.design_completion_date && this.props.touched.design_completion_date && {color: "red"}}>
                        Design Completion Date
                        <Field
                            className="form-control-sm form-control"
                            name={"design_completion_date"}
                            value={this.props.values.design_completion_date || null}
                        /> {this.props.errors.design_completion_date && this.props.touched.design_completion_date && (
                <small className="text-danger">{this.props.errors.design_completion_date}</small>
            )}
                    </label>

                    <label className="col-3 pl-2" style={this.props.errors.design_start_date && this.props.touched.design_start_date && {color: "red"}}>
                        Design Start Date
                        <Field
                            className="form-control-sm form-control"
                            name={"design_start_date"}
                            value={this.props.values.design_start_date || null}
                        /> {this.props.errors.design_start_date && this.props.touched.design_start_date && (
                <small className="text-danger">{this.props.errors.design_start_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.engineers_cost_estimate && this.props.touched.engineers_cost_estimate && {color: "red"}}>

                        Engineers Cost Estimate
                        <Field
                            className="form-control-sm form-control"
                            name={"engineers_cost_estimate"}
                            value={this.props.values.engineers_cost_estimate || null}
                        /> {this.props.errors.engineers_cost_estimate && this.props.touched.engineers_cost_estimate && (
                        <small className="text-danger">{this.props.errors.engineers_cost_estimate}</small>
                    )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.engineers_cost_estimate_date && this.props.touched.engineers_cost_estimate_date && {color: "red"}}>
                        Engineers Cost Estimate Date
                        <Field
                            className="form-control-sm form-control"
                            name={"engineers_cost_estimate_date"}
                            value={this.props.values.engineers_cost_estimate_date || null}
                        /> {this.props.errors.engineers_cost_estimate_date && this.props.touched.engineers_cost_estimate_date && (
                <small className="text-danger">{this.props.errors.engineers_cost_estimate_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.engineers_estimated_substantial_completion_date && this.props.touched.engineers_estimated_substantial_completion_date && {color: "red"}}>
                        Engineers Estimated Substantial Completion Date
                        <Field
                            className="form-control-sm form-control"
                            name={"engineers_estimated_substantial_completion_date"}
                            value={
                                this.props.values
                                    .engineers_estimated_substantial_completion_date || null
                            }
                        /> {this.props.errors.engineers_estimated_substantial_completion_date && this.props.touched.engineers_estimated_substantial_completion_date && (
                <small className="text-danger">{this.props.errors.engineers_estimated_substantial_completion_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.engieering_estimated_final_completion_date && this.props.touched.engieering_estimated_final_completion_date && {color: "red"}}>
                        Engineering Estimated Final Completion Date
                        <Field
                            className="form-control-sm form-control"
                            name={"engieering_estimated_final_completion_date"}
                            value={
                                this.props.values.engieering_estimated_final_completion_date || null
                            }
                        /> {this.props.errors.engieering_estimated_final_completion_date && this.props.touched.engieering_estimated_final_completion_date && (
                        <small className="text-danger">{this.props.errors.engieering_estimated_final_completion_date}</small>
                    )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.final_completion_date && this.props.touched.final_completion_date && {color: "red"}}>
                        Final Completion Date
                        <Field
                            className="form-control-sm form-control"
                            name={"final_completion_date"}
                            value={this.props.values.final_completion_date || null}
                        /> {this.props.errors.final_completion_date && this.props.touched.final_completion_date && (
                <small className="text-danger">{this.props.errors.final_completion_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.financial_close_date && this.props.touched.financial_close_date && {color: "red"}}>
                        Financial Close Date
                        <Field
                            className="form-control-sm form-control"
                            name={"financial_close_date"}
                            value={this.props.values.financial_close_date || null}
                        /> {this.props.errors.financial_close_date && this.props.touched.financial_close_date && (
                <small className="text-danger">{this.props.errors.financial_close_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.fte_hours_to_oversee_procurement && this.props.touched.fte_hours_to_oversee_procurement && {color: "red"}}>
                        Fte Hours To Oversee Procurement
                        <Field
                            className="form-control-sm form-control"
                            name={"fte_hours_to_oversee_procurement"}
                            value={this.props.values.fte_hours_to_oversee_procurement || null}
                        /> {this.props.errors.fte_hours_to_oversee_procurement && this.props.touched.fte_hours_to_oversee_procurement && (
                <small className="text-danger">{this.props.errors.fte_hours_to_oversee_procurement}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.liquidated_damage_cost && this.props.touched.liquidated_damage_cost && {color: "red"}}>
                        Liquidated Damage Cost
                        <Field
                            className="form-control-sm form-control"
                            name={"liquidated_damage_cost"}
                            value={this.props.values.liquidated_damage_cost || null}
                        /> {this.props.errors.liquidated_damage_cost && this.props.touched.liquidated_damage_cost && (
                <small className="text-danger">{this.props.errors.liquidated_damage_cost}</small>
            )}
                    </label>

                    <label className="col-3 pl-2" style={this.props.errors.num_change_orders && this.props.touched.num_change_orders && {color: "red"}}>
                        Num Change Orders
                        <Field
                            className="form-control-sm form-control"
                            name={"num_change_orders"}
                            value={this.props.values.num_change_orders || null}
                        /> {this.props.errors.num_change_orders && this.props.touched.num_change_orders && (
                <small className="text-danger">{this.props.errors.num_change_orders}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.num_of_claims && this.props.touched.num_of_claims && {color: "red"}}>
                        Num Of Claims
                        <Field
                            className="form-control-sm form-control"
                            name={"num_of_claims"}
                            value={this.props.values.num_of_claims || null}
                        /> {this.props.errors.num_of_claims && this.props.touched.num_of_claims && (
                <small className="text-danger">{this.props.errors.num_of_claims}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.deis && this.props.touched.deis && {color: "red"}}>
                        Num Of RFI Submittals
                        <Field
                            className="form-control-sm form-control"
                            name={"num_of_rfi_submittals"}
                            value={this.props.values.num_of_rfi_submittals || null}
                        /> {this.props.errors.num_of_rfi_submittals && this.props.touched.num_of_rfi_submittals && (
                <small className="text-danger">{this.props.errors.num_of_rfi_submittals}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.num_of_rfp_addenda_by_purpose && this.props.touched.num_of_rfp_addenda_by_purpose && {color: "red"}}>
                        Num Of RFP Addenda By Purpose
                        <Field
                            className="form-control-sm form-control"
                            name={"num_of_rfp_addenda_by_purpose"}
                            value={this.props.values.num_of_rfp_addenda_by_purpose || null}
                        /> {this.props.errors.num_of_rfp_addenda_by_purpose && this.props.touched.num_of_rfp_addenda_by_purpose && (
                <small className="text-danger">{this.props.errors.num_of_rfp_addenda_by_purpose}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.num_of_rfq_submittals && this.props.touched.num_of_rfq_submittals && {color: "red"}}>

                        Num Of RFQ Submittals
                        <Field
                            className="form-control-sm form-control"
                            name={"num_of_rfq_submittals"}
                            value={this.props.values.num_of_rfq_submittals || null}
                        /> {this.props.errors.num_of_rfq_submittals && this.props.touched.num_of_rfq_submittals && (
                <small className="text-danger">{this.props.errors.num_of_rfq_submittals}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.num_of_submittals_in_response_to_rfp && this.props.touched.num_of_submittals_in_response_to_rfp && {color: "red"}}>

                        Num Of Submittals In Response To RFP
                        <Field
                            className="form-control-sm form-control"
                            name={"num_of_submittals_in_response_to_rfp"}
                            value={this.props.values.num_of_submittals_in_response_to_rfp || null}
                        /> {this.props.errors.num_of_submittals_in_response_to_rfp && this.props.touched.num_of_submittals_in_response_to_rfp && (
                <small className="text-danger">{this.props.errors.num_of_submittals_in_response_to_rfp}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.number_of_days_of_liquidated_damage && this.props.touched.number_of_days_of_liquidated_damage && {color: "red"}}>

                        Number Of Days Of Liquidated Damage
                        <Field
                            className="form-control-sm form-control"
                            name={"number_of_days_of_liquidated_damage"}
                            value={this.props.values.number_of_days_of_liquidated_damage || null}
                        /> {this.props.errors.number_of_days_of_liquidated_damage && this.props.touched.number_of_days_of_liquidated_damage && (
                <small className="text-danger">{this.props.errors.number_of_days_of_liquidated_damage}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.number_of_subcontractors && this.props.touched.number_of_subcontractors && {color: "red"}}>

                        Number Of Subcontractors
                        <Field
                            className="form-control-sm form-control"
                            name={"number_of_subcontractors"}
                            value={this.props.values.number_of_subcontractors || null}
                        /> {this.props.errors.number_of_subcontractors && this.props.touched.number_of_subcontractors && (
                <small className="text-danger">{this.props.errors.number_of_subcontractors}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.project_cost_at_financial_close && this.props.touched.project_cost_at_financial_close && {color: "red"}}>

                        Project Cost At Financial Close
                        <Field
                            className="form-control-sm form-control"
                            name={"project_cost_at_financial_close"}
                            value={this.props.values.project_cost_at_financial_close || null}
                        /> {this.props.errors.project_cost_at_financial_close && this.props.touched.project_cost_at_financial_close && (
                        <small className="text-danger">{this.props.errors.project_cost_at_financial_close}</small>
                    )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.project_cost_at_commercial_close && this.props.touched.project_cost_at_commercial_close && {color: "red"}}>

                        Project Cost At Commercial Close
                        <Field
                            className="form-control-sm form-control"
                            name={"project_cost_at_commercial_close"}
                            value={this.props.values.project_cost_at_commercial_close || null}
                        /> {this.props.errors.project_cost_at_commercial_close && this.props.touched.project_cost_at_commercial_close && (
                        <small className="text-danger">{this.props.errors.project_cost_at_commercial_close}</small>
                    )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfi_issue_date && this.props.touched.rfi_issue_date && {color: "red"}}>

                        RFI Issue Date
                        <Field
                            className="form-control-sm form-control"
                            name={"rfi_issue_date"}
                            value={this.props.values.rfi_issue_date || null}
                        /> {this.props.errors.rfi_issue_date && this.props.touched.rfi_issue_date && (
                <small className="text-danger">{this.props.errors.rfi_issue_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfi_response_date && this.props.touched.rfi_response_date && {color: "red"}}>

                        RFI Response Date
                        <Field
                            className="form-control-sm form-control"
                            name={"rfi_response_date"}
                            value={this.props.values.rfi_response_date || null}
                        /> {this.props.errors.rfi_response_date && this.props.touched.rfi_response_date && (
                <small className="text-danger">{this.props.errors.rfi_response_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfp_award_date && this.props.touched.rfp_award_date && {color: "red"}}>

                        RFP Award Date
                        <Field
                            className="form-control-sm form-control"
                            name={"rfp_award_date"}
                            value={this.props.values.rfp_award_date || null}
                        /> {this.props.errors.rfp_award_date && this.props.touched.rfp_award_date && (
                <small className="text-danger">{this.props.errors.rfp_award_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfp_issue_date && this.props.touched.rfp_issue_date && {color: "red"}}>

                        RFP Issue Date
                        <Field
                            className="form-control-sm form-control"
                            name={"rfp_issue_date"}
                            value={this.props.values.rfp_issue_date || null}
                        /> {this.props.errors.rfp_issue_date && this.props.touched.rfp_issue_date && (
                <small className="text-danger">{this.props.errors.rfp_issue_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfp_response_date && this.props.touched.rfp_response_date && {color: "red"}}>

                        RFP Response Date
                        <Field
                            className="form-control-sm form-control"
                            name={"rfp_response_date"}
                            value={this.props.values.rfp_response_date || null}
                        /> {this.props.errors.rfp_response_date && this.props.touched.rfp_response_date && (
                <small className="text-danger">{this.props.errors.rfp_response_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfq_evaluation_criteria_scoring && this.props.touched.rfq_evaluation_criteria_scoring && {color: "red"}}>

                        RFQ Evaluation Criteria Scoring
                        <Field
                            className="form-control-sm form-control"
                            name={"rfq_evaluation_criteria_scoring"}
                            value={this.props.values.rfq_evaluation_criteria_scoring || null}
                        /> {this.props.errors.rfq_evaluation_criteria_scoring && this.props.touched.rfq_evaluation_criteria_scoring && (
                <small className="text-danger">{this.props.errors.rfq_evaluation_criteria_scoring}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfq_issue_date && this.props.touched.rfq_issue_date && {color: "red"}}>

                        RFQ Issue Date
                        <Field
                            className="form-control-sm form-control"
                            name={"rfq_issue_date"}
                            value={this.props.values.rfq_issue_date || null}
                        /> {this.props.errors.rfq_issue_date && this.props.touched.rfq_issue_date && (
                <small className="text-danger">{this.props.errors.rfq_issue_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfq_response_date && this.props.touched.rfq_response_date && {color: "red"}}>

                        RFQ Response Date
                        <Field
                            className="form-control-sm form-control"
                            name={"rfq_response_date"}
                            value={this.props.values.rfq_response_date || null}
                        /> {this.props.errors.rfq_response_date && this.props.touched.rfq_response_date && (
                <small className="text-danger">{this.props.errors.rfq_response_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.rfq_shortlisting_date && this.props.touched.rfq_shortlisting_date && {color: "red"}}>

                        RFQ Shortlisting Date
                        <Field
                            className="form-control-sm form-control"
                            name={"rfq_shortlisting_date"}
                            value={this.props.values.rfq_shortlisting_date || null}
                        /> {this.props.errors.rfq_shortlisting_date && this.props.touched.rfq_shortlisting_date && (
                <small className="text-danger">{this.props.errors.rfq_shortlisting_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.schedule_savings_of_all_approved_atcs && this.props.touched.schedule_savings_of_all_approved_atcs && {color: "red"}}>

                        Schedule Savings Of All Approved ATCs
                        <Field
                            className="form-control-sm form-control"
                            name={"schedule_savings_of_all_approved_atcs"}
                            value={
                                this.props.values.schedule_savings_of_all_approved_atcs || null
                            }
                        /> {this.props.errors.schedule_savings_of_all_approved_atcs && this.props.touched.schedule_savings_of_all_approved_atcs && (
                <small className="text-danger">{this.props.errors.schedule_savings_of_all_approved_atcs}</small>
            )}
                    </label>

                    <label className="col-3 pl-2" style={this.props.errors.substantial_completion_date && this.props.touched.substantial_completion_date && {color: "red"}}>

                        Substantial Completion Date
                        <Field
                            className="form-control-sm form-control"
                            name={"substantial_completion_date"}
                            value={this.props.values.substantial_completion_date || null}
                        /> {this.props.errors.substantial_completion_date && this.props.touched.substantial_completion_date && (
                <small className="text-danger">{this.props.errors.substantial_completion_date}</small>
            )}
                    </label>

                    <label className="col-3 pl-2" style={this.props.errors.total_stipends && this.props.touched.total_stipends && {color: "red"}}>

                        Total Stipends
                        <Field
                            className="form-control-sm form-control"
                            name={"total_stipends"}
                            value={this.props.values.total_stipends || null}
                        /> {this.props.errors.total_stipends && this.props.touched.total_stipends && (
                <small className="text-danger">{this.props.errors.total_stipends}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.value_change_orders && this.props.touched.value_change_orders && {color: "red"}}>

                        Value Change Orders
                        <Field
                            className="form-control-sm form-control"
                            name={"value_change_orders"}
                            value={this.props.values.value_change_orders || null}
                        /> {this.props.errors.value_change_orders && this.props.touched.value_change_orders && (
                <small className="text-danger">{this.props.errors.value_change_orders}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.value_of_claims && this.props.touched.value_of_claims && {color: "red"}}>

                        Value Of Claims
                        <Field
                            className="form-control-sm form-control"
                            name={"value_of_claims"}
                            value={this.props.values.value_of_claims || null}
                        /> {this.props.errors.value_of_claims && this.props.touched.value_of_claims && (
                <small className="text-danger">{this.props.errors.value_of_claims}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.winning_bidder_estimated_final_completion_date && this.props.touched.winning_bidder_estimated_final_completion_date && {color: "red"}}>

                        Winning Bidder Estimated Final Completion Date
                        <Field
                            className="form-control-sm form-control"
                            name={"winning_bidder_estimated_final_completion_date"}
                            value={
                                this.props.values
                                    .winning_bidder_estimated_final_completion_date || null
                            }
                        /> {this.props.errors.winning_bidder_estimated_final_completion_date && this.props.touched.winning_bidder_estimated_final_completion_date && (
                <small className="text-danger">{this.props.errors.winning_bidder_estimated_final_completion_date}</small>
            )}
                    </label>
                    <label className="col-3 pl-2" style={this.props.errors.winning_bidder_estimated_substantial_completion_date && this.props.touched.winning_bidder_estimated_substantial_completion_date && {color: "red"}}>

                        Winning Bidder Estimated Substantial Completion Date
                        <Field
                            className="form-control-sm form-control"
                            name={"winning_bidder_estimated_substantial_completion_date"}
                            value={
                                this.props.values
                                    .winning_bidder_estimated_substantial_completion_date || null
                            }
                        /> {this.props.errors.winning_bidder_estimated_substantial_completion_date && this.props.touched.winning_bidder_estimated_substantial_completion_date && (
                <small className="text-danger">{this.props.errors.winning_bidder_estimated_substantial_completion_date}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.advisory_contracts_to_support_the_procument_process && this.props.touched.advisory_contracts_to_support_the_procument_process && {color: "red"}}>

                        Advisory Contracts To Support The Procument Process
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"advisory_contracts_to_support_the_procument_process"}
                            value={
                                this.props.values
                                    .advisory_contracts_to_support_the_procument_process || null
                            }
                        /> {this.props.errors.advisory_contracts_to_support_the_procument_process && this.props.touched.advisory_contracts_to_support_the_procument_process && (
                <small className="text-danger">{this.props.errors.advisory_contracts_to_support_the_procument_process}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.approval_atcs && this.props.touched.approval_atcs && {color: "red"}}>

                        Approval ATCs
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"approval_atcs"}
                            value={this.props.values.approval_atcs || null}
                        /> {this.props.errors.approval_atcs && this.props.touched.approval_atcs && (
                <small className="text-danger">{this.props.errors.approval_atcs}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.asset_quality_indicator && this.props.touched.asset_quality_indicator && {color: "red"}}>

                        Asset Quality Indicator
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"asset_quality_indicator"}
                            value={this.props.values.asset_quality_indicator || null}
                        /> {this.props.errors.asset_quality_indicator && this.props.touched.asset_quality_indicator && (
                <small className="text-danger">{this.props.errors.asset_quality_indicator}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.change_order_description && this.props.touched.change_order_description && {color: "red"}}>

                        Change Order Description
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"change_order_description"}
                            value={this.props.values.change_order_description || null}
                        /> {this.props.errors.change_order_description && this.props.touched.change_order_description && (
                <small className="text-danger">{this.props.errors.change_order_description}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.construction_cost && this.props.touched.construction_cost && {color: "red"}}>

                        Construction Cost
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"construction_cost"}
                            value={this.props.values.construction_cost || null}
                        /> {this.props.errors.construction_cost && this.props.touched.construction_cost && (
                <small className="text-danger">{this.props.errors.construction_cost}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.cost_savings_of_all_approved_atcs && this.props.touched.cost_savings_of_all_approved_atcs && {color: "red"}}>

                        Cost Savings Of All Approved ATCs
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"cost_savings_of_all_approved_atcs"}
                            value={this.props.values.cost_savings_of_all_approved_atcs || null}
                        /> {this.props.errors.cost_savings_of_all_approved_atcs && this.props.touched.cost_savings_of_all_approved_atcs && (
                <small className="text-danger">{this.props.errors.cost_savings_of_all_approved_atcs}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.design_cost && this.props.touched.design_cost && {color: "red"}}>

                        Design Cost
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"design_cost"}
                            value={this.props.values.design_cost || null}
                        /> {this.props.errors.design_cost && this.props.touched.design_cost && (
                <small className="text-danger">{this.props.errors.design_cost}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.innovations && this.props.touched.innovations && {color: "red"}}>

                        Innovations
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"innovations"}
                            value={this.props.values.innovations || null}
                        /> {this.props.errors.innovations && this.props.touched.innovations && (
                <small className="text-danger">{this.props.errors.innovations}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.major_claim_description && this.props.touched.major_claim_description && {color: "red"}}>

                        Major Claim Description
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"major_claim_description"}
                            value={this.props.values.major_claim_description || null}
                        /> {this.props.errors.major_claim_description && this.props.touched.major_claim_description && (
                <small className="text-danger">{this.props.errors.major_claim_description}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.notes && this.props.touched.notes && {color: "red"}}>

                        Notes
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"notes"}
                            value={this.props.values.notes || ""}
                        /> {this.props.errors.notes && this.props.touched.notes && (
                <small className="text-danger">{this.props.errors.notes}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.other_project_cost && this.props.touched.other_project_cost && {color: "red"}}>

                        Other Project Cost
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"other_project_cost"}
                            value={this.props.values.other_project_cost || null}
                        /> {this.props.errors.other_project_cost && this.props.touched.other_project_cost && (
                <small className="text-danger">{this.props.errors.other_project_cost}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.primary_construction_methods && this.props.touched.primary_construction_methods && {color: "red"}}>

                        Primary Construction Methods
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"primary_construction_methods"}
                            value={this.props.values.primary_construction_methods || null}
                        /> {this.props.errors.primary_construction_methods && this.props.touched.primary_construction_methods && (
                <small className="text-danger">{this.props.errors.primary_construction_methods}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.rfp_evaluation_criteria_scoring && this.props.touched.rfp_evaluation_criteria_scoring && {color: "red"}}>

                        RFP Evaluation Criteria Scoring
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"rfp_evaluation_criteria_scoring"}
                            value={this.props.values.rfp_evaluation_criteria_scoring || null}
                        /> {this.props.errors.rfp_evaluation_criteria_scoring && this.props.touched.rfp_evaluation_criteria_scoring && (
                <small className="text-danger">{this.props.errors.rfp_evaluation_criteria_scoring}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.rfq_shortlisted_proposers && this.props.touched.rfq_shortlisted_proposers && {color: "red"}}>

                        RFQ Shortlisted Proposers
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"rfq_shortlisted_proposers"}
                            value={this.props.values.rfq_shortlisted_proposers || null}
                        /> {this.props.errors.rfq_shortlisted_proposers && this.props.touched.rfq_shortlisted_proposers && (
                <small className="text-danger">{this.props.errors.rfq_shortlisted_proposers}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.source_of_funding && this.props.touched.source_of_funding && {color: "red"}}>

                        Source Of Funding
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"source_of_funding"}
                            value={this.props.values.source_of_funding || null}
                        /> {this.props.errors.source_of_funding && this.props.touched.source_of_funding && (
                <small className="text-danger">{this.props.errors.source_of_funding}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.sources_of_revenues && this.props.touched.sources_of_revenues && {color: "red"}}>

                        Sources Of Revenues
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"sources_of_revenues"}
                            value={this.props.values.sources_of_revenues || null}
                        /> {this.props.errors.sources_of_revenues && this.props.touched.sources_of_revenues && (
                <small className="text-danger">{this.props.errors.sources_of_revenues}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.sureties_bonds && this.props.touched.sureties_bonds && {color: "red"}}>

                        Sureties Bonds
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"sureties_bonds"}
                            value={this.props.values.sureties_bonds || null}
                        /> {this.props.errors.sureties_bonds && this.props.touched.sureties_bonds && (
                <small className="text-danger">{this.props.errors.sureties_bonds}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.total_actual_cost && this.props.touched.total_actual_cost && {color: "red"}}>

                        Total Actual Cost
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"total_actual_cost"}
                            value={this.props.values.total_actual_cost || null}
                        /> {this.props.errors.total_actual_cost && this.props.touched.total_actual_cost && (
                <small className="text-danger">{this.props.errors.total_actual_cost}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.total_design_construction_cost && this.props.touched.total_design_construction_cost && {color: "red"}}>

                        Total Design Construction Cost
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"total_design_construction_cost"}
                            value={this.props.values.total_design_construction_cost || null}
                        /> {this.props.errors.total_design_construction_cost && this.props.touched.total_design_construction_cost && (
                <small className="text-danger">{this.props.errors.total_design_construction_cost}</small>
            )}
                    </label>
                    <label className="col-6 pl-2 d-block" style={this.props.errors.use_of_funds && this.props.touched.use_of_funds && {color: "red"}}>

                        Use Of Funds
                        <Field
                            component={"textarea"}
                            className="form-control-sm form-control"
                            name={"use_of_funds"}
                            value={this.props.values.use_of_funds || null}
                        /> {this.props.errors.use_of_funds && this.props.touched.use_of_funds && (
                <small className="text-danger">{this.props.errors.use_of_funds}</small>
            )}
                    </label>
                    <div>
            <SelectionFields
              showError={
                this.props.errors.proj_type_id &&
                this.props.touched.proj_type_id
              }
              size={"col-12"}
              id={"proj_type_id"}
              url={"projecttype"}
              showElem={"name"}
              label={"Project Type"}
              value={this.props.values["proj_type_id"] || "default"}
              isRequired={true}
              errorMessage={
                this.props.errors.proj_type_id &&
                this.props.touched.proj_type_id && (
                  <small className={"text-danger"}>
                    {this.props.errors.proj_type_id}
                  </small>
                )
              }
            />
          </div>
          <div>
            <SelectionFields
              showError={
                this.props.errors.procurement_model_id &&
                this.props.touched.procurement_model_id
              }
              size={"col-12"}
              id={"procurement_model_id"}
              url={"procurementmodel"}
              showElem={"name"}
              label={"Procurement Model"}
              value={this.props.values["procurement_model_id"] || "default"}
              isRequired={true}
              errorMessage={
                this.props.errors.procurement_model_id &&
                this.props.touched.procurement_model_id && (
                  <small className={"text-danger"}>
                    {this.props.errors.procurement_model_id}
                  </small>
                )
              }
            />
          </div>

                </fieldset>

                {this.props.disabled ? (<Button type="button" onClick={this.props.toggleSmallModalHandler}  className={"ml-2"}>
                    Cancel
                </Button>) : (
                    <div>
                        {!this.props.currentContract ? (
                            <Aux>
                                <Button
                                    color={"blue"}
                                    type="button"
                                    onClick={() => {
                                        validAndHandle(this.props.add, this.props.values);
                                    }}
                                >
                                    Submit
                                </Button>
                                <Button type="button" onClick={this.props.handleReset} color={"red"} className={"ml-2"}>
                                    Reset
                                </Button>
                            </Aux>
                        ) : (
                            <Aux>
                                <Button
                                    color={"blue"}
                                    type="button"
                                    onClick={() => {
                                        validAndHandle(this.props.update, this.props.values);
                                    }}
                                >
                                    Update
                                </Button>
                                <Button type="button" onClick={this.props.handleReset} color={"red"} className={"ml-2"}>
                                    Reset
                                </Button>
                            </Aux>
                        )}
                        <Button
                            className={"ml-2"}
                            type="button" onClick={this.props.toggleSmallModalHandler}>
                            Cancel
                        </Button>
                    </div>
                )}
            </Form>
        );
    }
}

var contractSchema = Yup.object().shape({
    contract_name: Yup.string().required(),
    is_master_contract: Yup.boolean().required(),
    design_start_date: Yup.date().nullable().typeError("Invalid date"),
    design_completion_date: Yup.date().nullable().typeError("Invalid date"),
    construction_start_date: Yup.date().nullable().typeError("Invalid date"),
    substantial_completion_date: Yup.date().nullable().typeError("Invalid date"),
    final_completion_date: Yup.date().nullable().typeError("Invalid date"),
    rfi_issue_date: Yup.date().nullable().typeError("Invalid date"),
    rfi_response_date: Yup.date().nullable().typeError("Invalid date"),
    rfq_issue_date: Yup.date().nullable().typeError("Invalid date"),
    rfq_response_date: Yup.date().nullable().typeError("Invalid date"),
    rfq_shortlisting_date: Yup.date().nullable().typeError("Invalid date"),
    rfp_issue_date: Yup.date().nullable().typeError("Invalid date"),
    rfp_response_date: Yup.date().nullable().typeError("Invalid date"),
    rfp_award_date: Yup.date().nullable().typeError("Invalid date"),
    contract_award_date: Yup.date().nullable().typeError("Invalid date"),
    commercial_close_date: Yup.date().nullable().typeError("Invalid date"),
    engineers_cost_estimate_date: Yup.date().nullable().typeError("Invalid date"),
    engineers_estimated_substantial_completion_date: Yup.date().nullable().typeError("Invalid date"),
    engieering_estimated_final_completion_date: Yup.date().nullable().typeError("Invalid date"),
    winning_bidder_estimated_substantial_completion_date: Yup.date().nullable().typeError("Invalid date"),
    winning_bidder_estimated_final_completion_date: Yup.date().nullable().typeError("Invalid date"),
    financial_close_date: Yup.date().nullable().typeError("Invalid date"),
    additional_days_gained: Yup.number().nullable().typeError("Number required"),
    display_order: Yup.number().nullable().typeError("Number required"),
    number_of_days_of_liquidated_damage: Yup.number().nullable().typeError("Number required"),
    num_change_orders: Yup.number().nullable().typeError("Number required"),
    value_change_orders: Yup.number().nullable().typeError("Number required"),
    num_of_claims: Yup.number().nullable().typeError("Number required"),
    value_of_claims: Yup.number().nullable().typeError("Number required"),
    liquidated_damage_cost: Yup.number().nullable().typeError("Number required"),
    num_of_rfi_submittals: Yup.number().nullable().typeError("Number required"),
    num_of_rfq_submittals: Yup.number().nullable().typeError("Number required"),
    num_of_rfp_addenda_by_purpose: Yup.number().nullable().typeError("Number required"),
    num_of_submittals_in_response_to_rfp: Yup.number().nullable().typeError("Number required"),
    total_stipends: Yup.number().nullable().typeError("Number required"),
    number_of_subcontractors: Yup.number().nullable().typeError("Number required"),
    fte_hours_to_oversee_procurement: Yup.number().nullable().typeError("Number required"),
    engineers_cost_estimate: Yup.number().nullable().typeError("Number required"),
    project_cost_at_commercial_close: Yup.number().nullable().typeError("Number required"),
    project_cost_at_financial_close: Yup.number().nullable().typeError("Number required"),
    project_type_id: Yup.number().nullable().typeError("Number required"),
    procurement_model_id: Yup.number().nullable().typeError("Number required"),
});

export default withFormik({
    validationSchema: contractSchema,
    enableReinitialize: true,

    mapPropsToValues({ currentContract }) {
        return {
            ...currentContract
        };
    }
})(ContractForm);
